import apiServices from 'config/apiServiceApiGateway'

import {
  PersonalizeAttributeType,
  PersonalizeDetailType,
  PersonalizeIdentifierTypeEnum,
} from '../@types/Personalization'

const { Get, Post } = apiServices

type GetPersonalizationAttributesResponseType = {
  attribute_params: PersonalizeAttributeType[]
}

export type CreatePersonalizationRequestPayloadType = {
  rule: {
    identifier: number
    identifier_type: PersonalizeIdentifierTypeEnum
    rules_string: string
  }
}

export type UpdatePersonalizationRequestPayloadType = CreatePersonalizationRequestPayloadType

export type DeletePersonalizationRequestPayloadType = Omit<
  CreatePersonalizationRequestPayloadType['rule'],
  'rules_string'
>

export type GetPersonalizationDetailResponseDataType = {
  rule: PersonalizeDetailType
}

export const getPersonalizationAttributes = () =>
  Get<GetPersonalizationAttributesResponseType, true>({
    url: '/browse/internal/v1/personalization/get-attribute-params',
  })

export const getPersonalizationDetailApi = (
  identifier: number,
  identifierType: PersonalizeIdentifierTypeEnum,
) =>
  Get<GetPersonalizationDetailResponseDataType, true>({
    url: '/browse/internal/:version/personalization/perso-rules/by-id-type/:identifier/:identifierType',
    version: 'v1',
    urlParams: { identifier, identifierType },
  })

export const createPersonalizationApi = (payload: CreatePersonalizationRequestPayloadType) =>
  Post({
    url: '/browse/internal/v1/personalization/perso-rules/insert',
    data: payload,
  })

export const updatePersonalizationApi = (payload: UpdatePersonalizationRequestPayloadType) =>
  Post({
    url: '/browse/internal/v1/personalization/perso-rules/update',
    data: payload,
  })

export const deletePersonalizationApi = (payload: DeletePersonalizationRequestPayloadType) =>
  Post({
    url: '/browse/internal/v1/personalization/perso-rules/delete',
    data: payload,
  })
